import { Component, Input } from '@angular/core';
import type { AddressFormContent, FormAddress } from '@innogy/common-ui/forms';
import { TrackToolStep } from '@analytics/models';
import { FormGroupState } from 'ngrx-forms';
import { getFieldValue } from '@core/jss-utils';
import {
  ProgressiveFormStepWrapperComponent,
  ProgressiveFormBodyDirective,
  ProgressiveFormSummaryDirective,
} from '@innogy/shared/progressive-form';
import { AddressFormComponent } from '@innogy/common-ui/forms';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

import { ProgressiveAddressFormRendering } from './progressive-address-form.rendering';

@Component({
  selector:
    'wl-progressive-address-form[rendering][trackStep][formState][progressiveFormSelectorKey][showAddressTypeSelector]',
  templateUrl: './progressive-address-form.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    AddressFormComponent,
    ProgressiveFormSummaryDirective,
    CSMaskDirective,
  ],
})
export class ProgressiveAddressFormComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() floatingLabels!: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ProgressiveAddressFormRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() trackStep!: TrackToolStep;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() formState!: FormGroupState<FormAddress>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() showAddressTypeSelector!: boolean;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;

  get addressFormContent(): AddressFormContent {
    return {
      PostalCodeLabel: getFieldValue(this.rendering, 'PostalCodeLabel', ''),
      PostalCodePlaceholder: getFieldValue(
        this.rendering,
        'PostalCodePlaceholder',
        ''
      ),
      PostalCodeRequiredError: getFieldValue(
        this.rendering,
        'PostalCodeRequiredError',
        ''
      ),
      PostalCodeNotValidError: getFieldValue(
        this.rendering,
        'PostalCodeFormattingError',
        ''
      ),
      HouseNumberLabel: getFieldValue(this.rendering, 'HouseNumberLabel', ''),
      HouseNumberPlaceholder: getFieldValue(
        this.rendering,
        'HouseNumberPlaceholder',
        ''
      ),
      HouseNumberRequiredError: getFieldValue(
        this.rendering,
        'HouseNumberRequiredError',
        ''
      ),
      HouseNumberNotValidError: '',
      HouseNumberAdditionLabel: '',
      HouseNumberAdditionPlaceholder: getFieldValue(
        this.rendering,
        'HouseNumberAdditionPlaceholder',
        ''
      ),
      HouseNumberAdditionMaxLengthError: getFieldValue(
        this.rendering,
        'HouseNumberAdditionMaxLengthError',
        ''
      ),
      AddressNotFoundErrorTitle: getFieldValue(
        this.rendering,
        'AddressNotFoundErrorTitle',
        ''
      ),
      AddressNotFoundErrorMessage: getFieldValue(
        this.rendering,
        'AddressNotFoundErrorMessage',
        ''
      ),
      AddressOptionLabel: getFieldValue(
        this.rendering,
        'AddressOptionLabel',
        ''
      ),
      PoboxOptionLabel: getFieldValue(this.rendering, 'PoboxOptionLabel', ''),
      CityLabel: getFieldValue(this.rendering, 'CityLabel', ''),
      CityPlaceholder: getFieldValue(this.rendering, 'CityPlaceholder', ''),
      CityRequiredError: getFieldValue(this.rendering, 'CityRequiredError', ''),
      StreetLabel: getFieldValue(this.rendering, 'StreetLabel', ''),
      StreetPlaceholder: getFieldValue(this.rendering, 'StreetPlaceholder', ''),
      StreetRequiredError: getFieldValue(
        this.rendering,
        'StreetRequiredError',
        ''
      ),
      PoboxLabel: getFieldValue(this.rendering, 'PoboxLabel', ''),
      PoboxRequiredError: getFieldValue(
        this.rendering,
        'PoboxRequiredError',
        ''
      ),
    };
  }
}
